import XApi from "../../utils/Api";
import XEndpoints from "../../core/config/Endpoints";

export class InventoryService {
    async update(id: string, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.inventory}/detail/${id}`, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }
}